import React, { useEffect, useState, useCallback } from "react";
import Slider from "react-slick";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Pageheading from "../../components/PageHeading/Pageheading";
import { RiHome2Line } from "react-icons/ri";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BiRightArrowAlt } from "react-icons/bi";
// import "./Category.css";
import CustomPlaybutton from "../../components/Buttons/CustomPlaybutton";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import bg from "../../assets/bg_image/banner.png";
import Page from "../../components/CatList/Page";
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import Button from "../../components/Buttons/Button";
import MobileSlider from "../../components/CostomSlider/MobileSlider";
import Aos from "aos";
import { Allcommercials, commercials } from "../../data/CategoryData";

const DummyVideo = ({ pageHeading }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [playVideo, setPlayVideo] = useState(false);
  const [activeIndex, setActiveIndex] = useState(1);
  const navigate = useNavigate();
  const location = useLocation();

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    nextArrow: <FiChevronRight className="absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer opacity-80 z-10" size={30} color="white" />, 
    prevArrow: <FiChevronLeft className="absolute left-4 top-1/2 -translate-y-1/2 cursor-pointer opacity-80 z-10" size={30} color="white" />, 
    beforeChange: (current, next) => setActiveIndex(next),
  };

  const videothumbnail = commercials[activeIndex].thumbnail;
  const videoId = commercials[activeIndex].videoId;

  const handleVideoLoad = useCallback(() => {
    setIsVideoLoaded(true);
  }, []);

  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);

  return (
    <div className="relative w-full h-[60vh] md:h-[80vh] overflow-hidden">
      <Slider {...settings}>
        {commercials.map((item, index) => (
          <div key={index} className="relative w-full h-full">
            <div
              className="absolute inset-0 w-full h-full bg-cover bg-center transition-all duration-500"
              style={{ backgroundImage: `url(${item.thumbnail})` }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {isHovered && (
                <iframe
                  src={`https://player.vimeo.com/video/${item.videoId}?autoplay=1&loop=1&muted=1&controls=0`}
                  className="absolute w-full h-full object-cover transition-opacity duration-500"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                  onLoad={handleVideoLoad}
                ></iframe>
              )}
            </div>
            <div className="absolute bottom-10 left-10 text-white">
              <h2 className="text-3xl font-bold">{item.title}</h2>
              <p className="text-lg">{item.description}</p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default DummyVideo;
